import { Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'

const useStyles = makeStyles({
	container: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		gap: '24px',
		backgroundColor: '#9469A9',
		padding: '8px 24px',
		'@media (min-width: 600px)': {
			paddingRight: '56px',
		},
		'@media (min-width: 1280px)': {
			paddingLeft: '32px',
		},
	},
	text: {
		fontSize: '0.875rem',
		lineHeight: 1.5,
		color: '#ffffff',
		textAlign: 'center',
	},
	link: {
		textDecoration: 'none',
		background: 'none',
		border: 'none',
		cursor: 'pointer',
		color: 'inherit',
	},
	strong: {
		fontWeight: 600,
	},
	divider: {
		display: 'inline-block',
		margin: '0 8px',
		width: '4px',
		height: '4px',
		borderRadius: '50%',
		backgroundColor: 'currentColor',
		verticalAlign: 'middle',
	},
	arrow: {
		marginLeft: '4px',
	},
	closeButton: {
		margin: '-12px',
		padding: '12px',
		flexShrink: 0,
		'&:focus': {
			outlineOffset: '-4px',
		},
	},
})

export default function FreeTrialBanner() {
	const classes = useStyles()
	const navigate = useNavigate()
	const { t } = useTranslation()
	const { t: tSubscriptionModals } = useTranslation('SubscriptionModals')

	return (
		<div className={classes.container}>
			<Typography className={classes.text}>
				<button
					type="button"
					className={classes.link}
					onClick={() => {
						navigate('/billing')
					}}
				>
					{tSubscriptionModals('banner.freeTrial')}
					<span className={classes.arrow} aria-hidden="true">
						&rarr;
					</span>
				</button>
			</Typography>
		</div>
	)
}
